import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JobsService } from 'core/services/jobs.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-customization-detail',
  templateUrl: './customization-detail.component.html',
  styleUrls: ['./customization-detail.component.scss']
})
export class CustomizationDetailComponent implements OnInit, OnDestroy {
  public customizationId: string = '';
  public customization: any;

  constructor(
    private route: ActivatedRoute,
    private jobsService: JobsService,
    private titleService: Title,
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      this.customizationId = params.get('customizationId');
    });
    this.titleService.setTitle(this.translateService.instant('roleplay.label'));
  }

  public ngOnDestroy(): void {}

  public setCustomization(event: any): void {
    const { customization } = event.detail;
    const { translations, ...tempCustomization } = customization;
    const translation = translations[this.translateService.currentLang] || translations['en'];

    this.customization = {
      ...tempCustomization,
      ...(translation ? translation : translations[Object.keys(translations)[0]])
    };
  }

  public savePlayers(event: any): void {
    const { job } = event.detail;
    this.jobsService.manageJob(job.jobId, this.jobsService.jobTypes.CREATE_PLAYERS_BULK);
  }

  public unsubscribePlayers(event: any): void {
    const { job } = event.detail;
    this.jobsService.manageJob(job.jobId, this.jobsService.jobTypes.UNSUBSCRIBE_PLAYERS_BULK);
  }
}
